module.exports = __webpack_public_path__ + "img/上传文件.f1454f81.png";